import React, { useEffect, useState } from "react";
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";
import Icon from "@mui/material/Icon";
import MKBox from "components/MKBox";
import MKPagination from "components/MKPagination";
import DefaultNavbar from "hanyeleo/Navbar";
import DefaultFooter from "examples/Footers/DefaultFooter";
import EventCard from "pages/Home/sections/EventCard";
import Testimonials from "pages/Home/sections/Testimonials";
import EventList from "pages/Home/sections/EventList";
// import routes from "routes";
import getNavRoutes from "../navroutes";
import footerRoutes from "footer.routes";
import Axios from "utils/Axios";
import product5 from "assets/images/HanyeIcon.png";
import { useSelector } from "react-redux";
import { useParams, useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { setCity } from "../redux/slices/city/citySlice";
import MKInput from "components/MKInput";
import { Autocomplete, TextField } from "@mui/material";

const itemsPerPage = 10;

function Home() {
  const dispatch = useDispatch();
  const { location } = useParams();
  const [data, setData] = useState([]);
  const [page, setPage] = useState(1);
  const [cities, setCities] = useState([]);
  const [slctdCity, setSlctdCity] = useState("");
  const [totalPages, setTotalPages] = useState(1);
  const selectedCity = useSelector((state) => state.city);
  const navigate = useNavigate();
  const [topEvents, setTopEvents] = useState([]);
  const [navRoutes, setNavRoutes] = useState([]);
  const [promoters, setPromoters] = useState([]);
  const [selectedPromoters, setSlctdPromoter] = useState("");
  const [venues, setVenues] = useState([]);
  const [selectedVenues, setSelectedVenues] = useState("");
  const [loading, setLoading] = useState(false);
  const token = localStorage.getItem("token");

  const fetchEvents = async (page = 1, city = "") => {
    setLoading(true);
    const cityParam = city ? `&city=${city}` : "";
    const promotersParam =
      selectedPromoters !== "" ? `&promoters=${selectedPromoters}` : "";
    const venuesParam = selectedVenues !== "" ? `&venues=${selectedVenues}` : "";
    Axios.get(`?type=event&event_time=future&page=${page}${cityParam}${promotersParam}${venuesParam}`)
      .then((response) => {
        const allData = response.data.data;
        const pagination = response.data.pagination;
        setData(allData);
        setTotalPages(pagination.totalPages);
        setLoading(false);
      })
      .catch((error) => {
        console.error("Failed to fetch events data", error);
        setLoading(false);
      });
  };

  const fetchPromoters = (venue = "") => {
    const venuesParam = venue !== "" ? `&venues=${venue}` : "";
    Axios.get(`?type=promoterActiveEvents${venuesParam}`)
      .then((response) => {
        setPromoters(response.data);
      })
      .catch((error) => {
        console.error("Failed to fetch promoters", error);
      });
  };
  const setSelectedPromoter = (promoter) => {
    if (!promoter) { 
      setSlctdPromoter("")
      fetchVenues("");
      return;
    }
    // selectedPromoters.push(promoter.value);
    setSlctdPromoter(promoter.value)
    fetchVenues(promoter.value);
    // fetchEvents(page, selectedCity.id);
  };
  const setSelectedVenue = (venue) => {
    if (!venue) {
      setSelectedVenues("");
      fetchPromoters(""); // Clear promoters if no venue is selected
      return;
    }
    setSelectedVenues(venue.name);
    fetchPromoters(venue.name);
    // fetchEvents(page, selectedCity.id);
  };
  const fetchVenues = (promoter = "") => {
    const promotersParam =
      promoter !== "" ? `&promoters=${promoter}` : "";
    Axios.get(`?type=venues${promotersParam}`)
      .then((response) => {
        setVenues(response.data);
      })
      .catch((error) => {
        console.error("Failed to fetch venues", error);
      });
  };
  const fetchTopEvents = async (city = "") => {
    const cityParam = city ? `&city=${city}` : "";
    Axios.get(`?type=top_events${cityParam}`)
      .then((response) => {
        const allData = response.data;
        setTopEvents(allData);
      })
      .catch((error) => {
        console.error("Failed to fetch top events data", error);
      });
  };

  const fetchCities = async () => {
    await Axios.get("?type=cities")
      .then((response) => {
        const citiesData = response.data;
        setCities(response.data);
        if (location) {
          const city = citiesData.find(
            (city) => city.title.toLowerCase() === `${location}`.toLowerCase()
          );

          if (!city) {
            dispatch(setCity({ title: "East Africa", id: "" }));
            navigate("/");
            return;
          } else {
            setSlctdCity(city.id);
            dispatch(setCity({ id: city.id, title: city.title }));
            navigate("/" + city.title.toLowerCase());
          }
        }
      })
      .catch((error) => {
        console.error("Failed to fetch countries:", error);
      });
  };

  const handleSelectCity = (cityId) => {
    setSlctdCity(cityId)
    if (!cityId) {
      dispatch(setCity({ title: "East Africa", id: "" }));
      navigate("/");
      return;
    }
    const selectedCity = cities.find((city) => city.id === cityId);
    if (selectedCity) {
      dispatch(setCity({ id: selectedCity.id, title: selectedCity.title }));
      navigate("/" + selectedCity.title.toLowerCase());
    }
  };

  useEffect(() => {
    setNavRoutes(getNavRoutes());
    fetchCities();
    fetchTopEvents(selectedCity.id);
    fetchPromoters();
    fetchVenues();
  }, []);

  useEffect(() => {
    setPage(1); // Reset to page 1 when filters change
    fetchEvents(1, selectedCity.id);
  }, [selectedVenues, selectedPromoters, selectedCity])

  useEffect(() => {
    fetchEvents(page, selectedCity.id);
  }, [page]);

  const SignIn = () => {
    navigate("/sign-in/"); // Redirect to login page
  };

  const EventGalleries = () => {
    navigate("/galleries");
  };

  const handlePageChange = (event, value) => {
    setPage(value);
  };

  return (
    <div className="min-h-screen bg-gray-100">
      <DefaultNavbar routes={navRoutes} relative center />

      <section className="bg-gray-100">
        <Container>
          <div className="flex flex-col-reverse md:flex-row items-center justify-between py-12 md:space-x-16 px-6">
            <div className="w-full md:w-1/2 text-center md:text-left mb-8 md:mb-0">
              <h1 className="text-3xl md:text-5xl font-bold text-black mb-4">
                Great Events Start at <span className="text-purple-800">HanyeLeo</span>
              </h1>
              <p className="text-gray-700 text-base md:text-lg mb-6">
                Welcome to HanyeLeo, bringing you the hottest events and parties!
              </p>
              <p className="text-sm md:text-base">
                Browse our event pages to see what's going on, and come back to view our image
                galleries of previous events.
              </p>
              <br></br>
              <div className="md:w-3/4 w-full">
                <MKInput
                  select
                  label=""
                  value={slctdCity}
                  onChange={(e) => {
                    handleSelectCity(e.target.value);
                  }}
                  fullWidth
                  SelectProps={{ native: true }}
                >
                  {/* <option value="" disabled>
                    Select a country
                  </option> */}
                  <option value="" >East Africa</option>
                  {cities?.map((city) => (
                    <option key={city.id} value={city.id}>
                      {" "}
                      {city.title}
                    </option>
                  ))}
                </MKInput>
              </div>
              <div className="mt-3">
                <button
                  type="button"
                  onClick={SignIn}
                  className="text-white bg-purple-800 hover:bg-purple-900 focus:ring-4 focus:ring-purple-400 font-medium rounded-lg text-xs md:text-sm px-8 md:px-16 py-2 md:py-3 me-2 mb-2"
                >
                  Get Started
                </button>
                <button
                  type="button"
                  onClick={EventGalleries}
                  className="text-white bg-purple-800 hover:bg-purple-900 focus:ring-4 focus:ring-purple-400 font-medium rounded-lg text-xs md:text-sm px-8 md:px-16 py-2 md:py-3 me-2 mb-2"
                >
                  Event Galleries
                </button>
              </div>
            </div>
            <div className="w-full md:w-1/2 flex items-center md:justify-end">
              <img src={product5} alt="Landing Image" />
            </div>
          </div>
        </Container>
      </section>

      <Container sx={{ mt: 5 }} className="pb-2">
        <div className="text-center mb-8 md:mb-16">
          <p className="text-2xl md:text-4xl lg:text-5xl font-bold text-gray-700 mb-4">Top Events</p>
        </div>
        <Grid container spacing={3}>
          {topEvents?.map((event) => (
            <EventCard key={event.title} {...event} />
          ))}
        </Grid>
      </Container>
      <Container>
      <hr style={{ marginTop: "35px", fontSize: "1px", color: "rgba(200, 200, 200, 0.18)" }} />
        <div className="flex md:flex-row flex-col gap-4 justify-center items-center mt-5">
          <div className="text-center lg:w-1/5 w-full">
            <Autocomplete
              disablePortal
              id="promoter-autocomplete"
              options={promoters}
              getOptionLabel={(option) => option.promoter}
              onChange={(event, value) => {
                setSelectedPromoter(value);
              }} // Set selected promoter
              renderInput={(params) => (
                <TextField {...params} label="Select Promoter" variant="outlined" />
              )}
            />
          </div>
          <div className="text-center lg:w-1/5 w-full">
            <Autocomplete
              disablePortal
              id="venue-autocomplete"
              options={venues}
              getOptionLabel={(option) => option?.name}
              onChange={(event, value) => {
                setSelectedVenue(value);
              }} // Set selected promoter
              renderInput={(params) => (
                <TextField {...params} label="Select Venue" variant="outlined" />
              )}
            />
          </div>
        </div>
      </Container>
      <EventList events={data} selectedLocation={selectedCity} loading={loading} />

      {/* Pagination */}
      <Container sx={{ mt: 5 }}>
        <MKPagination count={totalPages} page={page} onChange={handlePageChange}>
          <MKPagination item disabled={page === 1} onClick={() => handlePageChange(null, page - 1)}>
            <Icon>keyboard_arrow_left</Icon>
          </MKPagination>
          {[...Array(totalPages).keys()].map((pageNumber) => (
            <MKPagination
              item
              key={pageNumber + 1}
              onClick={() => handlePageChange(null, pageNumber + 1)}
              active={page === pageNumber + 1}
            >
              {pageNumber + 1}
            </MKPagination>
          ))}
          <MKPagination item disabled={page === totalPages} onClick={() => handlePageChange(null, page + 1)}>
            <Icon>keyboard_arrow_right</Icon>
          </MKPagination>
        </MKPagination>
      </Container>

      <Testimonials />

      <DefaultFooter content={footerRoutes} />
    </div>
  );
}

export default Home;
